import React, { useEffect, Suspense, useState } from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Loader from "../../components/Loader";
import Overview from './Overview';
import Projects from './Projects';
import Surroundings from './Surroundings';
import Gallery from './Gallery';
import Amenities from './Amenities';
import ProjectSlection from '../../components/projects/ProjectSelection';
import "../../../src/App.css"
import BlockSelction from '../../components/projects/BlockSelection';
import Navbar from '../../components/Navbar';


function Home() {
  const [windowInnerWidth, setWindowInnerWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Function to handle window resize event
    const handleResize = () => {
      setWindowInnerWidth(window.innerWidth);
    };

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <div style={{ height: "100%" }} className={windowInnerWidth < 576 ? "projectFilterSection1" : ""}>
        <Suspense fallback={<Loader />}>
          <BrowserRouter>
            <Navbar />
            <Routes>
              <Route path="overview" element={<Overview />}></Route>
              <Route index element={<Overview />} />
              <Route path="Navigator" element={<Projects />} />
              <Route path="location" element={<Surroundings />} />
              <Route path="gallery" element={<Gallery />} />
              <Route path="virtualtour" element={<Amenities />} />
              <Route path="projectSlection" element={<ProjectSlection />} />
              <Route path="blockSelction" element={<BlockSelction />} />
            </Routes>
          </BrowserRouter>
        </Suspense>
      </div>
      {/* <Login /> */}
    </>
  );
}

export default Home;